module.exports = "/assets/data/0ec962bab79ad764b66adce402052e5a-BN7.data.json";